
import React, { useLayoutEffect, useState, Fragment, useEffect } from 'react'
import { useRef } from "react";
import { IOMService } from '../../../apis/apiServices/InterOfficeMemo(IOM)'
import { Loader } from '../../Shared/PageLoader';
import { Button, SelectBox, CheckBox } from "devextreme-react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Popup from "devextreme-react/popup";
import TextArea from "devextreme-react/text-area";
import Swal from 'sweetalert2';
import { DepartmentService } from '../../../apis/apiServices/Department'
import { getUserByDepartmentId } from '../../../apis/apiServices/User'
import { Alert } from 'bootstrap';

export default function IOMViewComponent() {
    // const componentRef = useRef();
    //const contentRef = useRef < HTMLDivElement > (null);
    // const reactToPrintFn = useReactToPrint({
    //     content: () => contentRef.current,
    // });
    const user = useSelector((state) => state.user.data);
    const IsSendForReview = user?.levelCode === 'L4' || user?.levelCode === 'L5'
    const iomPendingCount = useSelector((state) => state.iomPendingCount.count);
    const location = useLocation();
    const navigate = useNavigate();
    const { iomId, isPreviewOnly, action, isApproved } = location.state || {};

    useLayoutEffect(() => {
        const initialize = async () => {
            document.querySelector("#pageTitle").innerHTML = "IOM - Inter Office Memorandum";
            await getIOMData(iomId);
            await getIOMRemarksByIomId(iomId);
            await getIOMAttachmentsByIomId(iomId);
            await getPreviousApprovedStatus();
            //await getDepartmentDropdown();
            await getUserForIOMRejection(iomId, user?.userId)
        };

        initialize();
    }, []);

    const [fileContent, setFileContent] = useState("");
    const [disableRecallButton, setDisableRecallButton] = useState(false);
    const [departmentDropdownData, setDepartmentDropdownData] = useState([]);
    const [userDropdownData, setUserDropdownData] = useState([]);
    const [iomData, setIOMData] = useState(null);
    const [charCount, setCharCount] = useState(0);
    const [previousApprovalStatus, setPreviousApprovalStatus] = useState(null);
    const [remarkIOM, setRemarkIOM] = useState(null);
    const [iomAttachmentData, setIOMAttachmentData] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isRecallModalVisible, setIsRecallModalVisible] = useState(false);
    const [isRejectModalVisible, setIsRejectModalVisible] = useState(false);
    const [isSendForReviewModalVisible, setIsSendForReviewModalVisible] = useState(false);
    const [isReviewedModalVisible, setIsReviewedModalVisible] = useState(false);
    const [userForRejectIOM, setUserForRejectIOM] = useState(false);
    const [remarks, setRemarks] = useState((action === "approveIom") ? "Approved from mail" : "");
    const [error, setError] = useState({ remarks: "", userIdForRejectIOM: "" });
    const [errorReview, setErrorReview] = useState({});
    const [loading, setLoading] = useState(false)
    const [userIdForRejectIOM, setUserIdForRejectIOM] = useState(null);
    const [reviewer, setReviewer] = useState({
        userId: 0,
        departmentId: 0,
        isEmail: false,
        isAddlog: true
    });


    const getDepartmentDropdownData = async () => {
        try {
            const response = await DepartmentService.getDepartmentDropdown()
            setDepartmentDropdownData(response?.data);
        } catch (error) {
            console.log("Error getDepartmentDropdown===>", error);
        }
    }

    const getIOMData = async () => {
        try {
            let body = { 'iomId': iomId }
            setLoading(true);
            const response = await IOMService.getIOMDetailsByIOMId(body)
            setIOMData(response?.data);
            setLoading(false);
            const approved = await IOMService.CheckApproveStatus(response?.data?.iomId, user?.userId);
            // 
            if (action === "approveIom") {
                const currentUserId = response?.data?.currentUserId;
                const iomStatusId = response?.data?.iomStatusId;

                if (currentUserId === user?.userId && iomStatusId === 9) {
                    Swal.fire({
                        icon: "warning",
                        text: "This IOM request is pending for previous approval.",
                    });
                    return;
                }
                else if (currentUserId !== user?.userId && iomStatusId === 9) {
                    Swal.fire({
                        icon: "warning",
                        text: "This IOM request is pending for previous approval.",
                    });
                    return;
                }
                else if (currentUserId !== user?.userId && iomStatusId === 4) {
                    Swal.fire({
                        icon: "warning",
                        text: "This IOM request has been sent back to draft.",
                    });
                    return;
                }
                else if (currentUserId === user?.userId && iomStatusId === 4) {
                    Swal.fire({
                        icon: "warning",
                        text: "This IOM request has been sent back to draft.",
                    });
                    return;
                }
                else if (currentUserId !== 0 && currentUserId !== user?.userId) {
                    Swal.fire({
                        icon: "warning",
                        text: "You have already approved this IOM Request.",
                    });
                    return;
                }
                else if (approved?.data) {
                    Swal.fire({
                        icon: "warning",
                        text: "You have already approved this IOM Request.",
                    });
                    return;
                }
                else {
                    setRemarks(response?.data?.currentUserStatusName || "approved");
                    setIsModalVisible(true);
                }
            }

        } catch (error) {
            console.log("Error getIOMList===>", error);
        }
    }

    const getIOMRemarksByIomId = async () => {
        //debugger;
        try {
            const response = await IOMService.getIOMRemarksByIomId(iomId)
            setRemarkIOM(response?.data);
        } catch (error) {
            console.log("Error getIOMRemarksByIomId===>", error);
        }
    }

    const getIOMAttachmentsByIomId = async () => {
        try {
            const response = await IOMService.getIOMAttachmentsByIomId(iomId)
            setIOMAttachmentData(response?.data);
        } catch (error) {
            console.log("Error getIOMAttachmentsByIomId===>", error);
        }
    }

    const getPreviousApprovedStatus = async () => {
        try {
            const response = await IOMService.getPreviousApprovedStatus(iomId, user?.userId)
            setPreviousApprovalStatus(response?.data);
        } catch (error) {
            console.log("Error getPreviousApprovedStatus===>", error);
        }
    }

    const getUserForIOMRejection = async () => {
        try {
            const response = await IOMService.getIOMUserForReject(iomId, user?.userId)
            setUserForRejectIOM(response?.data);
        } catch (error) {
            console.log("Error getUserForIOMRejection===>", error);
        }
    }

    const getUsersByDepartment = async (departmentId) => {
        try {
            const response = await getUserByDepartmentId(departmentId)
            // get list of approver userIds
            const approverIds = iomData?.approvers?.map(a => a?.userId) || [];
            // filter response
            const filteredUsers = response?.data?.filter(user => !approverIds.includes(user?.id));
            setUserDropdownData(filteredUsers);
        } catch (error) {
            console.log("Error getUsersByDepartmentId===>", error);
        }
    }

    const recommendDate = remarkIOM
        ?.find(item => item.iomStatusId === 2)
        ?.remarkDate;


    let recommendDateUTC = null;

    if (recommendDate) {
        const dateObj = new Date(recommendDate);
        recommendDateUTC = `${String(dateObj.getUTCDate()).padStart(2, '0')}-${String(dateObj.getUTCMonth() + 1).padStart(2, '0')}-${dateObj.getUTCFullYear()} ${String(dateObj.getUTCHours()).padStart(2, '0')}:${String(dateObj.getUTCMinutes()).padStart(2, '0')}:${String(dateObj.getUTCSeconds()).padStart(2, '0')} UTC`;
    }

    const approvedDate = remarkIOM
        ?.find(item => item.iomStatusId === 1)
        ?.remarkDate;

    // const approvedDateUTC = approvedDate
    //     ? new Date(approvedDate).toUTCString()
    //     : null;

    let approvedDateUTC = null;

    if (approvedDate) {
        const dateObj = new Date(approvedDate);
        approvedDateUTC = `${String(dateObj.getUTCDate()).padStart(2, '0')}-${String(dateObj.getUTCMonth() + 1).padStart(2, '0')}-${dateObj.getUTCFullYear()} ${String(dateObj.getUTCHours()).padStart(2, '0')}:${String(dateObj.getUTCMinutes()).padStart(2, '0')}:${String(dateObj.getUTCSeconds()).padStart(2, '0')} UTC`;
    }


    const handleSubmit = async () => {
        const newError = {};

        if (!remarks?.trim()) {
            newError.remarks = "Please enter remarks";
        } else if (remarks?.length > 300) {
            newError.remarks = "Remarks cannot exceed 300 characters";
        } else {
            setError({ remarks: "", userIdForRejectIOM: "" });
        }

        if (Object.keys(newError).length > 0) {
            setError(newError);
            return;
        }

        setIsModalVisible(false);
        setRemarks("");
        setError({});
        // const matchedApprover = iomData?.approvers?.find(
        //     (approver) => approver?.userId === user?.userId
        // );
        const matchedApprover = iomData?.approvers?.find(
            (approver) => approver?.stageId === iomData?.currentStageId
        );
        let body = {
            userId: user.userId,
            updatedOn: new Date(),
            recommendedOn: new Date(),
            approvedOn: new Date(),
            remarks: remarks || "",
            iomStatusId: (iomData?.currentStageId !== iomData?.lastStageId && matchedApprover?.statusId === 1) ? 3 : matchedApprover?.statusId,
            iomId: iomData?.iomId || 0,
            currentStageId: iomData?.currentStageId || 0,
        };
        setLoading(true)
        const response = await IOMService.approveIOM(body);
        setLoading(false)
        if (!response?.isSuccess) {
            Swal.fire(
                "Error!",
                `${response?.data?.message}`,
                "error"
            ).then(() => {
                // if (action === "approveIom") {
                //     window.close();
                // }
            })

            return;
        }
        Swal.fire(
            "Success!",
            `${response?.message}`,
            "success"
        ).then(() => {
            // if (action === "approveIom") {
            //     window.close();
            // }
            if (user?.isIframe) {
                window.parent.postMessage(
                    { type: "CLOSE_IFRAME" },
                    process.env.REACT_APP_VISHWAM_BASE_URL // 👈 parent domain
                );
                return;
            }

            if (location?.state?.fromPendingPage === true) {
                navigate("/pending-ioms");
                //console.log("reduxcount", iomPendingCount);
            } else {
                navigate("/inter-office-memo");
            }
        });
    };

    const handleRejectSubmit = async () => {
        //e.preventDefault();
        const newError = {};

        if (!remarks?.trim()) {
            newError.remarks = "Please enter remarks";
        } else if (remarks?.length > 300) {
            newError.remarks = "Remarks cannot exceed 300 characters";
        }

        if (!userIdForRejectIOM) {
            newError.userIdForRejectIOM = "Please select user";
        }

        if (Object.keys(newError).length > 0) {
            setError(newError);
            return;
        }

        // No errors, proceed
        setIsRejectModalVisible(false);
        setRemarks("");
        setUserIdForRejectIOM(null);
        setError({});


        let body = {
            userId: user.userId,
            sendRejectToUserId: userIdForRejectIOM,
            remarks: remarks || "",
            iomStatusId: 4,
            //IsRecommededUser: user?.userId === iomData?.recommendId ? true : false,
            iomId: iomData?.iomId || 0,
        };
        setLoading(true)
        const response = await IOMService.approveIOM(body);
        setLoading(false)
        if (!response?.isSuccess) {
            Swal.fire(
                "Error!",
                `${response?.data?.message}`,
                "error"
            ).then(() => {
                // if (action === "approveIom") {
                //     window.close();
                // }
            })
            return;
        }
        Swal.fire(
            "Success!",
            `${response?.message}`,
            "success"
        ).then(() => {

            if (user?.isIframe) {
                window.parent.postMessage(
                    { type: "CLOSE_IFRAME" },
                    process.env.REACT_APP_VISHWAM_BASE_URL // 👈 parent domain
                );
                return;
            }
            // if (action === "approveIom") {
            //     window.close();
            // }
            if (location?.state?.fromPendingPage === true) {
                navigate("/pending-ioms");
            } else if (location?.state?.fromRecallRequestPage === true) {
                navigate("/recall-requests");
            } else {
                navigate("/inter-office-memo");
            }
        });
    };
    const handleReviewSubmit = async () => {
        //e.preventDefault();
        const newError = {};

        if (!reviewer?.departmentId) {
            newError.departmentId = "Please select department";
        }
        if (!reviewer?.userId) {
            newError.userId = "Please select user";
        }

        if (Object.keys(newError).length > 0) {
            setErrorReview(newError);
            return;
        }

        // No errors, proceed
        setIsSendForReviewModalVisible(false);
        setReviewer("");
        setErrorReview({});


        let body = {
            userId: user?.userId,
            reviewerId: reviewer?.userId,
            isEmail: reviewer?.isEmail,
            isAddLog: true,
            iomStatusId: 10,
            iomId: iomData?.iomId || 0,
        };
        setLoading(true)
        const response = await IOMService.sentIOMForReview(body);
        setLoading(false)
        if (!response?.isSuccess) {
            Swal.fire(
                "Error!",
                `${response?.data?.message}`,
                "error"
            ).then(() => {
                // if (action === "approveIom") {
                //     window.close();
                // }
            })
            return;
        }
        Swal.fire(
            "Success!",
            `${response?.message}`,
            "success"
        ).then(() => {
            // if (action === "approveIom") {
            //     window.close();
            // }
            if (user?.isIframe) {
                window.parent.postMessage(
                    { type: "CLOSE_IFRAME" },
                    process.env.REACT_APP_VISHWAM_BASE_URL // 👈 parent domain
                );
                return;
            }

            if (location?.state?.fromPendingPage === true) {
                navigate("/pending-ioms");
            } else if (location?.state?.fromRecallRequestPage === true) {
                navigate("/recall-requests");
            } else {
                navigate(-1);
            }
        });
    };

    const handleApproveRequestRecallSubmit = async () => {

        let body = {
            userId: user.userId,
            sendRejectToUserId: userIdForRejectIOM,
            remarks: "Recall request approved and send back to draft.",
            iomStatusId: 4,
            //IsRecommededUser: user?.userId === iomData?.recommendId ? true : false,
            iomId: iomData?.iomId || 0,
        };
        setLoading(true)
        const response = await IOMService.approveRecallRequestIOM(body);
        setLoading(false)
        if (!response?.isSuccess) {
            Swal.fire(
                "Error!",
                `${response?.data?.message}`,
                "error"
            ).then(() => {
                // if (action === "approveIom") {
                //     window.close();
                // }
            })
            return;
        }
        Swal.fire(
            "Success!",
            `${response?.message}`,
            "success"
        ).then(() => {
            // if (action === "approveIom") {
            //     window.close();
            // }
            if (location?.state?.fromPendingPage === true) {
                navigate("/pending-ioms");
            } else if (location?.state?.fromRecallRequestPage === true) {
                navigate("/recall-requests");
            } else {
                navigate("/inter-office-memo");
            }
        });
    };

    const handleRecallSubmit = async () => {
        //e.preventDefault();
        const newError = {};

        if (!remarks?.trim()) {
            newError.remarks = "Please enter remarks";
        } else if (remarks?.length > 300) {
            newError.remarks = "Remarks cannot exceed 300 characters";
        }


        if (Object.keys(newError).length > 0) {
            setError(newError);
            return;
        }

        // No errors, proceed
        setIsRecallModalVisible(false);
        setRemarks("");
        setError({});


        let body = {
            userId: user.userId,
            remarks: remarks || "",
            iomStatusId: 9,
            iomId: iomData?.iomId || 0,
        };
        setLoading(true)
        const response = await IOMService.requestToRecallIOM(body);
        setLoading(false)
        if (!response?.isSuccess) {
            Swal.fire(
                "Error!",
                `${response?.data?.message}`,
                "error"
            ).then(() => {
                // if (action === "approveIom") {
                //     window.close();
                // }
            })
            return;
        }
        Swal.fire(
            "Success!",
            `${response?.message}`,
            "success"
        ).then(() => {
            // if (action === "approveIom") {
            //     window.close();
            // }
            if (location?.state?.fromPendingPage === true) {
                navigate("/pending-ioms");
            } else {
                navigate(-1);
            }
        });
    };
    const handleReviewedSubmit = async () => {
        //e.preventDefault();
        const newError = {};

        if (!remarks?.trim()) {
            newError.remarks = "Please enter remarks";
        } else if (remarks?.length > 300) {
            newError.remarks = "Remarks cannot exceed 300 characters";
        }


        if (Object.keys(newError).length > 0) {
            setError(newError);
            return;
        }

        // No errors, proceed
        setIsReviewedModalVisible(false);
        setRemarks("");
        setError({});


        let body = {
            userId: user.userId,
            remarks: remarks || "",
            iomStatusId: 11,
            iomId: iomData?.iomId || 0,
        };
        setLoading(true)
        const response = await IOMService.reviewIom(body);
        setLoading(false)
        if (!response?.isSuccess) {
            Swal.fire(
                "Error!",
                `${response?.data?.message}`,
                "error"
            ).then(() => {
                // if (action === "approveIom") {
                //     window.close();
                // }
            })
            return;
        }
        Swal.fire(
            "Success!",
            `${response?.message}`,
            "success"
        ).then(() => {
            // if (action === "approveIom") {
            //     window.close();
            // }
            if (user?.isIframe) {
                window.parent.postMessage(
                    { type: "CLOSE_IFRAME" },
                    process.env.REACT_APP_VISHWAM_BASE_URL // 👈 parent domain
                );
                return;
            }
            if (location?.state?.fromPendingPage === true) {
                navigate("/pending-ioms");
            } else {
                navigate("/inter-office-memo");
            }
        });
    };

    const handleUserRejectChange = (e) => {
        setUserIdForRejectIOM(e.value);
        setError((prev) => ({ ...prev, userIdForRejectIOM: "" }));
    };

    const handleRemarksChangee = (e) => {
        //setRemarks(e.value || "");
        let errorTemp = error;
        errorTemp.remarks = "";
        //setError(errorTemp);
    };

    const handleAproveRemarksChange = (e) => {
        const value = e?.event?.target?.value?.slice(0, 300) || ""; // Auto-trim to 300 chars

        setRemarks(value);
        setCharCount(value.length);

        // Set error only if max limit was hit
        setError((prev) => ({
            ...prev,
            remarks: value.length >= 300
                ? "Remarks cannot exceed 300 characters"
                : "",
        }));
    };
    const handleRejectRemarksChange = (e) => {
        const value = e?.event?.target?.value?.slice(0, 300) || ""; // Auto-trim to 300 chars

        setRemarks(value);
        setCharCount(value.length);

        // Set error only if max limit was hit
        setError((prev) => ({
            ...prev,
            remarks: value.length >= 300
                ? "Remarks cannot exceed 300 characters"
                : "",
        }));
    };
    const handleRecallRemarksChange = (e) => {
        const value = e?.event?.target?.value?.slice(0, 300) || ""; // Auto-trim to 300 chars

        setRemarks(value);
        setCharCount(value.length);

        // Set error only if max limit was hit
        setError((prev) => ({
            ...prev,
            remarks: value.length >= 300
                ? "Remarks cannot exceed 300 characters"
                : "",
        }));
    };
    const handleReviewedRemarksChange = (e) => {
        const value = e?.event?.target?.value?.slice(0, 300) || ""; // Auto-trim to 300 chars

        setRemarks(value);
        setCharCount(value.length);

        // Set error only if max limit was hit
        setError((prev) => ({
            ...prev,
            remarks: value.length >= 300
                ? "Remarks cannot exceed 300 characters"
                : "",
        }));
    };

    const handleFormData = (key, value) => {
        setReviewer((prevState) => {
            return {
                ...prevState,
                [key]: value
            }
        });
    }

    // const PrintPreview = () => {

    const handlePrint = () => {
        // debugger;
        document.title = iomData?.serial_no;
        window.print();

    };

    const matchedApprover = iomData?.approvers?.find(
        (approver) => approver?.userId === user?.userId
    );

    const getTimeDifferenceInSeconds = (dateTimeString) => {
        // Parse the given string into a Date object
        const givenTime = new Date(dateTimeString);

        // Get current time
        const currentTime = new Date();

        // Calculate difference in milliseconds
        const diffMs = currentTime - givenTime;

        // Convert to seconds
        const diffSec = Math.floor(diffMs / 1000);

        return diffSec;
    }

    useEffect(() => {
        const approvedDate = (iomData?.approvers || []).find(
            approver => approver.userId === user?.userId
        )?.approvedDate;

        if (!approvedDate) return;

        const interval = setInterval(() => {
            const secondsDiff = getTimeDifferenceInSeconds(approvedDate);
            if (secondsDiff > 300) {
                setDisableRecallButton(true);
                clearInterval(interval); // Stop further checks
            }
        }, 1000); // every 5 seconds

        return () => clearInterval(interval); // Cleanup on unmount
    }, [iomData, user]);

    const totalBytes = iomAttachmentData
        ?.reduce((sum, item) => sum + Number(item.fileSize), 0);
    const totalMB = (totalBytes / (1024 * 1024)).toFixed(2);

    // }
    return (
        <Fragment>
            <div className="content">
                <div className='card top-bottom' >
                    {/* style={{ display: isPreviewOnly ? "none" : "" }} */}
                    <div className='card-body'>
                        <div className='row'>
                            <div className='col-lg-8 col-md-6 col-sm-12'>

                                {/* Reviewed Button for reviewer only */}
                                {(iomData?.reviewerUserId === user?.userId) &&
                                    <Button
                                        text={"Reviewed"}
                                        icon="edit"
                                        onClick={async () => {
                                            setIsReviewedModalVisible(true);
                                            //await getDepartmentDropdownData();
                                        }}
                                        stylingMode="contained"
                                        type="warning"
                                        className="mr-2"
                                        hint="Review"
                                    />
                                }

                                {/* Sent for approval Button */}
                                {(previousApprovalStatus &&
                                    iomData?.iomStatusId !== 9 && // <- Added this condition
                                    iomData?.iomStatusId !== 8 &&
                                    iomData?.iomStatusId !== 4 &&
                                    (iomData?.approvers || []).some(
                                        (approver) =>
                                            approver.userId === user?.userId &&
                                            approver?.approvedDate == null &&
                                            (iomData?.iomStatusId !== 4 || approver?.sendToUserForReject === user?.userId)
                                    )
                                ) && (
                                        <>
                                            {/* Sent for Review button */}
                                            {IsSendForReview && (
                                                <Button
                                                    text={"Send for Review"}
                                                    icon="edit"
                                                    onClick={async () => {
                                                        if (iomData?.reviewerStatusId === 10) {
                                                            Swal.fire({
                                                                icon: 'info',
                                                                title: 'Pending for Review',
                                                                text: 'This IOM is still pending for review.',
                                                            });
                                                        } else {
                                                            setIsSendForReviewModalVisible(true);
                                                            await getDepartmentDropdownData();
                                                        }
                                                    }}
                                                    stylingMode="contained"
                                                    type="warning"
                                                    className="mr-2"
                                                    hint="Sent for Review"
                                                />
                                            )}

                                            <Button
                                                text={iomData?.nextUserStatusText ? iomData?.nextUserStatusText : "Approve"}
                                                icon="check"
                                                onClick={() => {
                                                    if (iomData?.reviewerStatusId === 10) {
                                                        Swal.fire({
                                                            icon: 'info',
                                                            title: 'Pending for Review',
                                                            text: 'This IOM is still pending for review.',
                                                        });
                                                    } else {
                                                        setIsModalVisible(true);
                                                    }
                                                }}
                                                stylingMode="default"
                                                type="success"
                                                className="mr-2"
                                                hint={iomData?.nextUserStatusText ? iomData?.nextUserStatusText : "Approve"}
                                            />
                                            <Button
                                                text="Back to Draft"
                                                icon="back"
                                                onClick={async () => {
                                                    if (iomData?.reviewerStatusId === 10) {
                                                        Swal.fire({
                                                            icon: 'info',
                                                            title: 'Pending for Review',
                                                            text: 'This IOM is still pending for review.',
                                                        });
                                                        return; // stop here so it doesn't go to confirm dialog
                                                    }

                                                    const confirmResult = await Swal.fire({
                                                        title: "Are you sure?",
                                                        text: "Do you want to send the IOM back to draft?",
                                                        icon: "warning",
                                                        showCancelButton: true,
                                                        confirmButtonText: "Yes, continue",
                                                        cancelButtonText: "No, cancel"
                                                    });

                                                    if (confirmResult.isConfirmed) {
                                                        setIsRejectModalVisible(true);
                                                    }
                                                }}
                                                stylingMode="default"
                                                type="danger"
                                                className="mr-2"
                                                hint="Back to Draft"
                                            />
                                        </>
                                    )}

                                {/* send to draft button for recall request user */}
                                {location?.state?.fromRecallRequestPage === true &&
                                    <Button
                                        text="Approve Recall Request"
                                        icon="undo"
                                        onClick={async () => {
                                            const confirmResult = await Swal.fire({
                                                title: "Are you sure?",
                                                text: "Do you want to approve recall request?",
                                                icon: "warning",
                                                showCancelButton: true,
                                                confirmButtonText: "Yes",
                                                cancelButtonText: "No"
                                            });

                                            if (confirmResult.isConfirmed) {
                                                //handleRejectSubmit();
                                                handleApproveRequestRecallSubmit();
                                            }
                                        }}
                                        stylingMode="outlined"
                                        type="success"
                                        className="mr-2"
                                        hint="Approve Recall Request"
                                    />
                                }

                                {/* Request to recall */}
                                {(iomData?.approvers || []).some(
                                    (approver) =>
                                        approver.userId === user?.userId && approver?.approvedDate !== null
                                ) && (iomData?.iomStatusId !== 1 && iomData?.iomStatusId !== 9 && iomData?.iomStatusId !== 4 && iomData?.iomStatusId !== 8) &&!location?.state?.fromPendingPage &&  (
                                        <>
                                            <Button
                                                text="Request to Recall"
                                                icon="check"
                                                onClick={() => setIsRecallModalVisible(true)}
                                                stylingMode="outlined"
                                                type="danger"
                                                className="mr-2"
                                                hint='Request to recall'
                                            //disabled={getTimeDifferenceInSeconds((iomData?.approvers || []).find(approver => approver.userId === user?.userId)?.approvedDate) > 60}
                                            //disabled={disableRecallButton}
                                            ></Button>
                                        </>
                                    )}
                            </div>
                            <div className='col-lg-4 col-md-6 col-sm-12 text-right'>
                                <Button
                                    text="Back"
                                    icon="back"
                                    onClick={() => {
                                        navigate(-1);
                                    }}
                                    stylingMode="outlined"
                                    type="default"
                                    className='mr-2'
                                    hint='Back'
                                    visible={!user?.isIframe}
                                />
                                <button className='btn btn-primary btn-sm' title='Print' onClick={handlePrint}><i className="fas fa-print"></i> Print</button>
                            </div>
                        </div>

                        {/* Approval PopUp */}
                        <Popup
                            visible={isModalVisible}
                            onHiding={() => setIsModalVisible(false)}
                            showTitle={true}
                            title="Approval"
                            height="auto"
                            weight="auto"
                            className='custom-modal-popup'
                        >
                            <div className='popup-body'>
                                <div className='form-group'>
                                    <label>Remark <span className="text-danger">*</span></label>
                                    <TextArea
                                        value={remarks}
                                        onInput={(e) => handleAproveRemarksChange(e)}
                                        height={90}
                                        placeholder="Type your remarks..."
                                        maxLength={300}
                                    />
                                    <div style={{ fontSize: "12px", color: charCount > 300 ? "red" : "#999" }}>
                                        {charCount}/300 characters
                                    </div>
                                    {error.remarks && (
                                        <div style={{ color: "red" }}>{error.remarks}</div>
                                    )}
                                </div>

                            </div>
                            <div className='text-right'>

                                <Button
                                    icon='close'
                                    text="Cancel"
                                    onClick={() => {
                                        setIsModalVisible(false);
                                        setRemarks("");
                                        setError("");
                                    }}
                                    stylingMode="outlined"
                                    className="btn btn-outline-primary btn-sm mr-2" />
                                <Button
                                    icon='check'
                                    text="Submit"
                                    type="success"
                                    onClick={handleSubmit}
                                    className="btn btn-primary btn-sm"
                                />
                            </div>
                        </Popup>
                        {/* Reject PopUp */}
                        <Popup
                            visible={isRejectModalVisible}
                            onHiding={() => setIsRejectModalVisible(false)}
                            dragEnabled={false}
                            showTitle={true}
                            title="Back to Draft"
                            height="auto"
                            weight="auto"
                            className='custom-modal-popup'
                        >
                            <div className='popup-body'>
                                <div className='form-group'>
                                    <label>Send to <span className="text-danger">*</span></label>
                                    <div>
                                        <SelectBox
                                            dataSource={userForRejectIOM || []}
                                            valueExpr="userId"
                                            displayExpr="userName"
                                            className="form-control"
                                            placeholder="Select user"
                                            searchEnabled
                                            disabled={true}
                                            showClearButton={true}
                                            value={iomData?.createdByUserId}
                                            // onValueChanged={(e) => {
                                            //     setUserIdForRejectIOM(e.value);
                                            // }}
                                            onValueChanged={(e) => handleUserRejectChange(e)}
                                        />
                                        {error?.userIdForRejectIOM && (
                                            <div style={{ color: "red" }}>{error?.userIdForRejectIOM}</div>
                                        )}
                                    </div>
                                </div>
                                <div className='form-group'>
                                    <label>Remark <span className="text-danger">*</span></label>
                                    <div>
                                        <TextArea
                                            value={remarks}
                                            onInput={(e) => handleRejectRemarksChange(e)}
                                            height={90}
                                            placeholder="Type your remarks..."
                                            maxLength={300}
                                        />
                                        <div style={{ fontSize: "12px", color: charCount > 300 ? "red" : "#999" }}>
                                            {charCount}/300 characters
                                        </div>
                                        {error.remarks && (
                                            <div style={{ color: "red" }}>{error.remarks}</div>
                                        )}
                                    </div>
                                </div>


                            </div>
                            <div className='text-right'>
                                <Button icon='close'
                                    text="Cancel"
                                    onClick={() => {
                                        setIsRejectModalVisible(false);
                                        setRemarks("");
                                        setError("");
                                    }}
                                    stylingMode="outlined"
                                    className="btn btn-outline-primary btn-sm mr-2"
                                />
                                <Button
                                    icon='check'
                                    text="Submit"
                                    type="success"
                                    onClick={handleRejectSubmit}
                                    className="btn btn-primary btn-sm"
                                />
                            </div>
                        </Popup>
                        {/* send for Review PopUp */}
                        <Popup
                            visible={isSendForReviewModalVisible}
                            onHiding={() => setIsSendForReviewModalVisible(false)}
                            dragEnabled={false}
                            showTitle={true}
                            title="Send for Review"
                            height="auto"
                            weight="auto"
                            className='custom-modal-popup'
                        >
                            <div className='popup-body'>
                                <div className='form-group'>
                                    <label>Department <span className="text-danger">*</span></label>
                                    <div>
                                        <SelectBox
                                            dataSource={departmentDropdownData || []}
                                            valueExpr="id"
                                            displayExpr="name"
                                            className="form-control"
                                            placeholder="Select user"
                                            searchEnabled={true}
                                            showClearButton={true}
                                            value={reviewer?.departmentId || 0}
                                            onValueChanged={(e) => {

                                                handleFormData("departmentId", e?.value);
                                                getUsersByDepartment(e?.value || 0);
                                            }}

                                        />
                                        {errorReview?.departmentId && (
                                            <div style={{ color: "red" }}>{errorReview?.departmentId}</div>
                                        )}
                                    </div>
                                </div>
                                <div className='form-group'>
                                    <label>User <span className="text-danger">*</span></label>
                                    <div>
                                        <SelectBox
                                            dataSource={userDropdownData || []}
                                            valueExpr="id"
                                            displayExpr="name"
                                            className="form-control"
                                            placeholder="Select user"
                                            searchEnabled={true}
                                            showClearButton={true}
                                            value={reviewer?.userId || 0}
                                            onValueChanged={(e) => handleFormData("userId", e?.value)}
                                        />
                                        {errorReview?.userId && (
                                            <div style={{ color: "red" }}>{errorReview?.userId}</div>
                                        )}
                                    </div>
                                </div>
                                <div className='form-group'>
                                    <div className="form-group d-flex align-items-center" style={{ gap: "10px", marginTop: "10px" }}>
                                        <CheckBox
                                            value={reviewer?.isEmail}
                                            onValueChanged={(e) => handleFormData("isEmail", e.value)}
                                        />
                                        <label style={{ margin: 0 }}>Send email to user</label>
                                    </div>
                                </div>
                                {/* <div className='form-group'>
                                    <div className="form-group d-flex align-items-center" style={{ gap: "10px", marginTop: "10px" }}>
                                        <CheckBox
                                            value={reviewer?.isAddlog}
                                            onValueChanged={(e) => handleFormData("isAddlog", e.value)}
                                        />
                                        <label style={{ margin: 0 }}>Add to log history</label>
                                    </div>
                                </div> */}

                            </div>
                            <div className='text-right'>
                                <Button icon='close'
                                    text="Cancel"
                                    onClick={() => {
                                        setIsSendForReviewModalVisible(false);
                                        setReviewer({
                                            userId: 0,
                                            departmentId: 0,
                                            isEmail: false,
                                            isAddlog: false
                                        });
                                        setErrorReview("");
                                    }}
                                    stylingMode="outlined"
                                    className="btn btn-outline-primary btn-sm mr-2"
                                />
                                <Button
                                    icon='check'
                                    text="Submit"
                                    type="success"
                                    onClick={handleReviewSubmit}
                                    className="btn btn-primary btn-sm"
                                />
                            </div>
                        </Popup>
                        {/* Reviewed PopUp */}
                        <Popup
                            visible={isReviewedModalVisible}
                            onHiding={() => setIsReviewedModalVisible(false)}
                            dragEnabled={false}
                            showTitle={true}
                            title="Reviewed"
                            height="auto"
                            weight="auto"
                            className='custom-modal-popup'
                        >
                            <div className='popup-body'>
                                <div className='form-group'>
                                    <label>Remark <span className="text-danger">*</span></label>
                                    <div>
                                        <TextArea
                                            value={remarks}
                                            onInput={(e) => handleReviewedRemarksChange(e)}
                                            height={90}
                                            placeholder="Type your remarks..."
                                            maxLength={300}
                                        />
                                        <div style={{ fontSize: "12px", color: charCount > 300 ? "red" : "#999" }}>
                                            {charCount}/300 characters
                                        </div>
                                        {error.remarks && (
                                            <div style={{ color: "red" }}>{error.remarks}</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='text-right'>
                                <Button icon='close'
                                    text="Cancel"
                                    onClick={() => {
                                        setIsReviewedModalVisible(false);
                                        setRemarks("");
                                        setError("");
                                    }}
                                    stylingMode="outlined"
                                    className="btn btn-outline-primary btn-sm mr-2"
                                />
                                <Button
                                    icon='check'
                                    text="Submit"
                                    type="success"
                                    onClick={handleReviewedSubmit}
                                    className="btn btn-primary btn-sm"
                                />
                            </div>
                        </Popup>
                        {/* Recall PopUp */}
                        <Popup
                            visible={isRecallModalVisible}
                            onHiding={() => setIsRecallModalVisible(false)}
                            dragEnabled={false}
                            showTitle={true}
                            title="Request to Recall"
                            height="auto"
                            weight="auto"
                            className='custom-modal-popup'
                        >
                            <div className='popup-body'>
                                <div className='form-group'>
                                    <label>Remark <span className="text-danger">*</span></label>
                                    <div>
                                        <TextArea
                                            value={remarks}
                                            onInput={(e) => handleRecallRemarksChange(e)}
                                            height={90}
                                            placeholder="Type your remarks..."
                                            maxLength={300}
                                        />
                                        <div style={{ fontSize: "12px", color: charCount > 300 ? "red" : "#999" }}>
                                            {charCount}/300 characters
                                        </div>
                                        {error.remarks && (
                                            <div style={{ color: "red" }}>{error.remarks}</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='text-right'>
                                <Button icon='close'
                                    text="Cancel"
                                    onClick={() => {
                                        setIsRecallModalVisible(false);
                                        setRemarks("");
                                        setError("");
                                    }}
                                    stylingMode="outlined"
                                    className="btn btn-outline-primary btn-sm mr-2"
                                />
                                <Button
                                    icon='check'
                                    text="Submit"
                                    type="success"
                                    onClick={handleRecallSubmit}
                                    className="btn btn-primary btn-sm"
                                />
                            </div>
                        </Popup>
                    </div>
                </div>
                <div className='row'>
                    {/* {isPreviewOnly && <div className='col-lg-2 col-md-3'></div>} */}
                    {/* <div ref={contentRef}> */}
                    <div className={'col-lg-9 col-md-6'}>
                        <div className='card' >
                            <div className='card-body'>
                                <table width="100%" className='page-header'>
                                    <tr>
                                        <td><div className="imglogo mt-2"><img src="https://vishwasamudra.in/wp-content/uploads/2022/11/New-Project.png" alt="DigilinkZ | Streamlining Storage, Access & Organization" width="150" class="" /></div></td>
                                        <td align="right">
                                            <h6 className='mb-1' style={{ fontSize: '0.8rem', color: '#282C7D' }}>Registered Office</h6>
                                            <p className='mb-0 pb-0 small'>
                                                8th & 9th Floors, Vamsiram Jyothi Valencia,<br></br>
                                                Road No. 2, Banjara Hills, Hyderabad – 500034
                                            </p>
                                        </td>
                                    </tr>
                                </table>
                                <div className='text-center mt-5 mb-4 imo-page-title' style={{ backgroundColor: '#ebebeb', paddingTop: '7px', paddingBottom: '7px', border: '1px solid #ebebeb' }}>
                                    <table width="100%">
                                        <tr>
                                            <td className='text-center'><h4 className='mb-0' style={{ fontWeight: '700', color: '#282c7d' }}>Inter Office Memorandum</h4>
                                                <h6 className='mb-0 mr-3' style={{ fontWeight: '600' }}>{iomData?.serial_no}</h6></td>
                                            {/* <td width="50%" className='text-right'></td> */}
                                        </tr>
                                    </table>
                                </div>
                                <div className='imo-basic-detail'>
                                    <table cellPadding="2">
                                        <tr>
                                            <td width="80px" style={{ fontSize: '0.9rem' }}>From</td>
                                            <td style={{ fontSize: '0.9rem', fontWeight: '500', color: '#282C7D' }}>{iomData?.fromUser} {iomData?.fromDepartmentName ? ` (${iomData.fromDepartmentName})` : ''}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ fontSize: '0.9rem' }}>To</td>
                                            <td style={{ fontSize: '0.9rem', fontWeight: '500', color: '#282C7D' }}>{iomData?.toUser} {iomData?.toDepartmentName ? ` (${iomData.toDepartmentName})` : ''}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ fontSize: '0.9rem' }}>Subject</td>
                                            <td style={{ fontSize: '0.9rem', fontWeight: '500', color: '#282C7D' }}>{iomData?.subject}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ fontSize: '0.9rem' }}>Site</td>
                                            <td style={{ fontSize: '0.9rem', fontWeight: '500', color: '#282C7D' }}>{iomData?.projectName}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ fontSize: '0.9rem' }}>IOM No.</td>
                                            <td style={{ fontSize: '0.9rem', fontWeight: '500', color: '#282C7D' }}>{iomData?.serial_no}</td>
                                        </tr>
                                        {/* {iomData?.categoryName && (
                                            <tr>
                                                <td style={{ fontSize: '0.9rem' }}>Category</td>
                                                <td style={{ fontSize: '0.9rem', fontWeight: '500', color: '#282C7D' }}>
                                                    {iomData.categoryName}
                                                </td>
                                            </tr>
                                        )} */}
                                        <tr>
                                            <td style={{ fontSize: '0.9rem' }}>Date</td>
                                            <td style={{ fontSize: '0.9rem', fontWeight: '500', color: '#282C7D' }}>
                                                {iomData?.iomDate
                                                    ? new Date(iomData?.iomDate).toLocaleDateString('en-GB', {
                                                        day: '2-digit',
                                                        month: '2-digit',
                                                        year: 'numeric'
                                                    })
                                                    : ''
                                                }
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div><hr></hr></div>
                                <div className='message-body' dangerouslySetInnerHTML={{ __html: iomData?.iomContent }}></div>
                                <table width="100%" cellPadding="0" className='approvers'>
                                    <tr>
                                        {iomData?.approvers.map((approver, index) => {
                                            let label = '';
                                            if (approver?.statusId === 2) {
                                                label = 'Recommended By,';
                                            } else if (approver?.statusId === 3) {
                                                label = 'Drafted By,';
                                            } else if (approver?.statusId === 7) {
                                                label = 'Verified By,';
                                            } else if (approver?.statusId === 1) {
                                                label = 'Approved By,';
                                            }
                                            return approver?.statusId > 0 && (
                                                <td width="30%" align='center'>
                                                    <div key={index}>
                                                        {label && (
                                                            <h6 className='mb-0' style={{ fontSize: '0.9rem', fontStyle: 'normal', fontWeight: '400' }}>
                                                                {label}
                                                            </h6>
                                                        )}
                                                        <>
                                                            <div className='sender-name' style={{ height: '70px', paddingTop: '8px', position: 'relative' }}>
                                                                {approver?.approvedDate &&
                                                                    <>
                                                                        <div className='signature'>
                                                                            <img src="./assets/img/logo-vs-symbol.png" className="img-fluid logo-brand-image" />
                                                                        </div>
                                                                        <div className='digital-sign'>
                                                                            <div>Digitally signed by {approver?.firstName} {approver?.lastName}</div>
                                                                            <div>Date: {new Date(approver?.approvedDate).toLocaleDateString('en-GB', {
                                                                                day: '2-digit',
                                                                                month: '2-digit',
                                                                                year: 'numeric',
                                                                                hour: '2-digit',
                                                                                minute: '2-digit',
                                                                                hour12: true
                                                                            })}
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                }
                                                            </div>

                                                            <div className='sender-name' style={{
                                                                borderTop: '1px solid #cfcfcf',
                                                                paddingTop: '0.5rem',
                                                                fontSize: '0.9rem',
                                                                fontWeight: '500'
                                                            }}>
                                                                {approver?.firstName} {approver?.lastName}
                                                            </div>
                                                            <div className='sender-department' style={{ fontSize: '0.8rem' }}>
                                                                {approver?.designationName}
                                                            </div>
                                                        </>
                                                    </div>
                                                </td>
                                            );
                                        })}
                                    </tr>
                                </table>
                                <div className='page-footer'>
                                    www.vishwasamudra.in
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-3 col-md-3 reviews'>
                        {/* Remarks */}
                        <div className='card' >
                            <div className='card-body'>
                                <div className='mb-1 sub-title-color'>REMARKS</div>
                                <div class="list-group">
                                    {remarkIOM?.map((item, index) => (
                                        <div
                                            key={index}
                                            className="list-group-item list-group-item-action flex-column align-items-start" style={{ borderBottom: '1px solid #cfcfcf', marginBottom: '0.5rem', paddingBottom: '0.5rem' }}
                                        >
                                            <div className='small mb-1' style={{ color: '#282c7d', fontWeight: '500' }}>
                                                {item.iomStatus === 'Recall' ? "Recall Requested" : item.iomStatus === 'Review' ? "Sent for Review" : item.iomStatus} by {item.userName}
                                            </div>
                                            <div className="d-flex w-100 justify-content-between align-items-center">
                                                <small>Message</small>
                                                <small>
                                                    {item.remarkDate
                                                        ? new Date(item.remarkDate).toLocaleDateString('en-GB', {
                                                            day: '2-digit',
                                                            month: '2-digit',
                                                            year: 'numeric'
                                                        }) +
                                                        ' ' +
                                                        new Date(item.remarkDate).toLocaleTimeString('en-GB', {
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true
                                                        })
                                                        : ''}
                                                </small>
                                            </div>
                                            <div className="small" style={{ fontSize: '0.8rem', fontStyle: 'italic' }}>{item.remarks}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        {/* Attachments */}
                        {iomAttachmentData?.length === 0 ? "" :
                             <div className='card'>
        <div className='card-body'>
            <div className='mb-1 sub-title-color'>ATTACHMENTS</div>
            {/* Added scrollable container */}
            <div style={{ 
                maxHeight: '300px', 
                overflowY: 'auto', 
                overflowX: 'hidden' 
            }}>
                <div className="list-group">
                    {iomAttachmentData?.map((item, index) => (
                        <div
                            key={index}
                            className='list-group-item list-group-item-action flex-column align-items-start'
                            style={{ 
                                borderBottom: '1px solid #cfcfcf', 
                                marginBottom: '0.5rem', 
                                paddingBottom: '0.5rem' 
                            }}
                        >
                            <div className="d-flex w-100 justify-content-between align-items-center">
                                <small
                                    style={{ cursor: 'pointer', color: 'blue' }}
                                    onClick={() => {
                                        const fileUrl =
                                            process.env.REACT_APP_CDN_VISHWAM_BASE_URL +
                                            item?.filePath;
                                        window.open(fileUrl, '_blank');
                                    }}
                                >
                                    {item?.iomFileName}
                                </small>
                                <small>{(item?.fileSize / 1024).toFixed(0)}kb</small>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            {/* Total Size stays outside scrollable area */}
            <div className='list-group-item list-group-item-action flex-column align-items-start'>
                <div className="d-flex w-100 justify-content-between align-items-center">
                    <small>Total Size</small>
                    <small>{totalMB} Mb</small>
                </div>
            </div>
        </div>
    </div>
}
                    </div>
                </div>
                <div className='web-page-footer'>
                    www.vishwasamudra.in
                </div>
            </div>
            {loading && <Loader loadingMessage={""} />}
        </Fragment>
    )
}
